import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="font-medium mb-4 text-gray-800">About</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/sourcing" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Responsible Sourcing
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-medium mb-4 text-gray-800">Shop</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/engagement" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Engagement Rings
                </Link>
              </li>
              <li>
                <Link to="/bands" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Unisex Bands
                </Link>
              </li>
              <li>
                <Link to="/lifestyle" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Lifestyle Jewelry
                </Link>
              </li>
              <li>
                <Link to="/instock" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  In Stock Pieces
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-medium mb-4 text-gray-800">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/financing" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Financing Options
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Shipping & Returns
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="font-medium mb-4 text-gray-800">Connect</h3>
            <div className="flex gap-4 mb-4">
              <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">
                <Youtube size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors">
                <Mail size={20} />
              </a>
            </div>
            <p className="text-sm text-gray-600 mb-2">
              <a href="tel:214-952-0001" className="hover:text-gray-900">214-952-0001</a><br />
              <a href="mailto:dqkyukim@gmail.com" className="hover:text-gray-900">dqkyukim@gmail.com</a>
            </p>
            <p className="text-sm text-gray-600">
              2945 Walnut Hill Ln.<br />
              Dallas, Texas 75229
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 text-center text-sm text-gray-600">
          <p>© {new Date().getFullYear()} Diamond Q Jewelers. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;